import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { IconButton, PopupHoverContainer } from "@similarweb/ui-components";

import { useTranslation } from "../../WithTranslation/src/I18n";

const Container = styled.div<{ padding: string }>(
    ({ padding }) => `
    display: flex;
    align-items: center;
    padding: ${padding};
    height: 48px;
    ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon[500] })};
    justify-content: space-between;
    background-color: ${colorsPalettes.blue[100]};
    flex-shrink: 0;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`,
);

const Title = styled.div`
    ${mixins.setFont({ $weight: 500 })};
    margin-right: 4px;
`;

const Text = styled.div`
    margin-left: 8px;
    ${mixins.setFont({ $color: rgba(colorsPalettes.carbon[500], 0.8) })};
`;

const Link = styled.a`
    text-decoration: none;
    color: ${colorsPalettes.blue[400]};
    margin-left: 4px;
`;

const Left = styled.div`
    display: flex;
    align-items: center;
`;

interface IRecommendedWebsiteGroupBanner {
    onCloseClick: VoidFunction;
    learnMoreLink?: string;
    title: string;
    text: string;
    infoText?: string;
    displayShowMore?: boolean;
    containerPadding?: string;
}

export const RecommendedWebsiteGroupBanner = ({
    containerPadding = "0px 36px 0px 24px",
    displayShowMore = true,
    infoText,
    learnMoreLink,
    onCloseClick,
    text,
    title,
}: IRecommendedWebsiteGroupBanner) => {
    const translate = useTranslation();

    return (
        <Container padding={containerPadding}>
            <Left>
                <Title>{title}</Title>
                {displayShowMore ? (
                    <PopupHoverContainer
                        content={() => (
                            <span>
                                {infoText}
                                <Link
                                    href={learnMoreLink}
                                    target="_blank"
                                >
                                    {translate("workspaces.marketing.websitegroup.recommendation.banner.learn.more")}
                                </Link>
                            </span>
                        )}
                        config={{ placement: "top", width: 250, allowHover: true }}
                    >
                        <div>
                            <SWReactIcons
                                iconName="info"
                                size="xs"
                            />
                        </div>
                    </PopupHoverContainer>
                ) : null}
                <Text>{text}</Text>
            </Left>
            <div>
                <IconButton
                    iconName="clear"
                    iconSize="xs"
                    type="flat"
                    onClick={onCloseClick}
                />
            </div>
        </Container>
    );
};
